import { useState } from "react";
import { Eyebrow, Reveal } from "./Reveal";
import { BRAND_PARTNERS } from "../data/site";

export const LogoPill = ({ name, logo, className = "" }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span className={`inline-flex items-center justify-center border border-ink/10 bg-white px-4 py-2 ${className}`}>
      {!logo || failed ? (
        <span className="font-serif text-base font-semibold text-ink">{name}</span>
      ) : (
        <img
          src={logo}
          alt={`${name} logo`}
          loading="lazy"
          className="h-7 w-auto max-w-[110px] object-contain"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
};

const LogoCard = ({ partner }) => {
  const [failed, setFailed] = useState(false);
  return (
    <div
      data-testid={`brand-logo-${partner.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className="flex h-32 items-center justify-center border border-ink/10 bg-white p-3 transition-all duration-300 hover:-translate-y-1 hover:border-brand/60 hover:shadow-[0_18px_40px_-20px_rgba(192,57,43,0.35)]"
    >
      {!partner.logo || failed ? (
        <span className="font-serif text-lg font-semibold tracking-wide text-ink">{partner.name}</span>
      ) : (
        <img
          src={partner.logo}
          alt={`${partner.name} logo`}
          loading="lazy"
          className="h-20 w-full object-contain"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
};

export const BrandWall = () => (
  <section data-testid="brand-wall-section" className="py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal className="mb-12 text-center">
        <Eyebrow>Diversity of Brands</Eyebrow>
        <h2 className="mx-auto mt-4 max-w-2xl font-serif text-2xl font-medium leading-tight tracking-tight text-foreground sm:text-3xl lg:text-4xl">
          Every brand you trust, <em className="text-brand-gradient not-italic">on one floor.</em>
        </h2>
      </Reveal>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {BRAND_PARTNERS.map((p) => (
          <LogoCard key={p.name} partner={p} />
        ))}
      </div>
    </div>
  </section>
);
